import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="34"
    height="40"
    viewBox="0 0 34 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.9447 4.00023C25.9887 4.00023 26.0332 4.00369 26.0777 4.01071C26.3972 4.06135 26.6601 4.28882 26.7562 4.59767L27.8579 8.14205L31.4023 9.24382C31.7112 9.33982 31.9387 9.60281 31.9893 9.92226C32.0399 10.2417 31.9047 10.5621 31.6407 10.7489L28.6102 12.892L28.6577 16.6034C28.6618 16.9267 28.482 17.2244 28.1939 17.3712C27.9058 17.5181 27.5592 17.4885 27.3001 17.2951L24.3253 15.0753L20.8102 16.2673C20.5039 16.3711 20.1652 16.2921 19.9366 16.0634C19.7079 15.8348 19.6288 15.4961 19.7327 15.1898L20.9247 11.6747L18.7049 8.6999C18.5114 8.44077 18.4819 8.09425 18.6287 7.80612C18.7756 7.51799 19.0744 7.33912 19.3966 7.34229L23.108 7.38976L25.2511 4.35927C25.4119 4.13198 25.6717 4.00023 25.9447 4.00023Z"
      fill="#F7BB22"
    />
    <path
      d="M9.93509 20.409C10.1525 20.409 10.37 20.4919 10.5358 20.6579C10.8676 20.9896 10.8676 21.5276 10.5358 21.8594L6.53073 25.8644C6.19893 26.1962 5.66096 26.1963 5.32922 25.8644C4.99742 25.5327 4.99742 24.9947 5.32922 24.6629L9.33431 20.6579C9.50027 20.492 9.71771 20.409 9.93509 20.409Z"
      fill="#F4901B"
    />
    <path
      d="M7.93241 27.2178C8.14985 27.2178 8.36729 27.3008 8.53313 27.4667C8.86493 27.7985 8.86493 28.3364 8.53313 28.6682L4.45016 32.7512C4.11842 33.0829 3.58045 33.0829 3.24865 32.7512C2.91685 32.4195 2.91685 31.8815 3.24865 31.5497L7.33162 27.4667C7.49752 27.3008 7.71497 27.2178 7.93241 27.2178Z"
      fill="#F8B64C"
    />
    <path
      d="M11.7372 19.4563C12.069 19.788 12.607 19.788 12.9388 19.4563L18.1742 14.2208C18.506 13.889 18.506 13.3511 18.1742 13.0193C18.0083 12.8534 17.7909 12.7704 17.5735 12.7704C17.3561 12.7704 17.1386 12.8534 16.9728 13.0193L11.7373 18.2548C11.4054 18.5865 11.4054 19.1245 11.7372 19.4563Z"
      fill="#F8B64C"
    />
    <path
      d="M20.9491 21.0588L22.9802 19.0278C23.312 18.696 23.312 18.1581 22.9802 17.8263C22.8143 17.6603 22.5968 17.5774 22.3794 17.5774C22.162 17.5774 21.9445 17.6604 21.7787 17.8263L19.7476 19.8573C19.4158 20.189 19.4158 20.7269 19.7476 21.0588C20.0793 21.3906 20.6172 21.3906 20.9491 21.0588Z"
      fill="#F8B64C"
    />
    <path
      d="M10.9363 26.2649L17.3444 19.8568C17.6762 19.525 17.6762 18.987 17.3444 18.6552C17.1785 18.4893 16.9611 18.4064 16.7437 18.4064C16.5263 18.4064 16.3088 18.4893 16.143 18.6552L9.73485 25.0634C9.40305 25.3951 9.40305 25.9331 9.73485 26.2649C10.0666 26.5966 10.6046 26.5966 10.9363 26.2649Z"
      fill="#F4B24E"
    />
    <path
      d="M17.3446 22.26L10.1354 29.4691C9.80365 29.8009 9.80365 30.3388 10.1354 30.6706C10.4672 31.0024 11.0052 31.0024 11.337 30.6706L18.5461 23.4615C18.8779 23.1298 18.8779 22.5918 18.5461 22.26C18.3802 22.0941 18.1627 22.0111 17.9453 22.0111C17.728 22.0111 17.5105 22.0941 17.3446 22.26Z"
      fill="#F4901B"
    />
    <path
      d="M10.7595 11.9302L11.6092 11.9302L11.6092 12.7798C11.6092 13.249 11.9895 13.6294 12.4588 13.6294C12.928 13.6294 13.3084 13.249 13.3084 12.7798L13.3084 11.9302L14.158 11.9302C14.6272 11.9302 15.0076 11.5498 15.0076 11.0806C15.0076 10.6114 14.6272 10.231 14.158 10.231L13.3084 10.231L13.3084 9.38137C13.3084 8.91217 12.928 8.53177 12.4588 8.53177C11.9895 8.53177 11.6092 8.91216 11.6092 9.38137L11.6092 10.231L10.7595 10.231C10.2903 10.231 9.90994 10.6114 9.90994 11.0806C9.90994 11.5498 10.2903 11.9302 10.7595 11.9302Z"
      fill="#FFAA5C"
    />
    <path
      d="M27.7517 31.3008L28.6013 31.3008L28.6013 32.1504C28.6013 32.6196 28.9817 33 29.4509 33C29.9202 33 30.3005 32.6196 30.3005 32.1504L30.3005 31.3008L31.1502 31.3008C31.6194 31.3008 31.9998 30.9204 31.9998 30.4512C31.9998 29.982 31.6194 29.6016 31.1502 29.6016L30.3005 29.6016L30.3005 28.752C30.3005 28.2828 29.9202 27.9024 29.4509 27.9024C28.9817 27.9024 28.6013 28.2828 28.6013 28.752L28.6013 29.6016L27.7517 29.6016C27.2825 29.6016 26.9021 29.982 26.9021 30.4512C26.9021 30.9204 27.2825 31.3008 27.7517 31.3008Z"
      fill="#FFAA5C"
    />
    <path
      d="M22.9373 25.2403C22.9373 24.7711 22.5569 24.3907 22.0877 24.3907C21.6185 24.3907 21.2381 24.7711 21.2381 25.2403L21.2381 26.0899L20.3885 26.0899C19.9192 26.0899 19.5388 26.4703 19.5388 26.9395C19.5388 27.4087 19.9192 27.7891 20.3885 27.7891L21.2381 27.7891L21.2381 28.6387C21.2381 29.1079 21.6185 29.4883 22.0877 29.4883C22.5569 29.4883 22.9373 29.1079 22.9373 28.6387L22.9373 27.7891L23.7869 27.7891C24.2561 27.7891 24.6365 27.4087 24.6365 26.9395C24.6365 26.4703 24.2561 26.0899 23.7869 26.0899L22.9373 26.0899L22.9373 25.2403Z"
      fill="#F6C547"
    />
    <path
      d="M16.707 30.3374C16.2378 30.3374 15.8574 30.7178 15.8574 31.187C15.8574 31.6562 16.2378 32.0366 16.707 32.0366C17.1763 32.0366 17.5566 31.6562 17.5566 31.187C17.5566 30.7178 17.1763 30.3374 16.707 30.3374Z"
      fill="#F8B64C"
    />
    <path
      d="M28.0349 21.8418C27.5657 21.8418 27.1853 22.2222 27.1853 22.6914C27.1853 23.1606 27.5657 23.541 28.0349 23.541C28.5041 23.541 28.8845 23.1606 28.8845 22.6914C28.8845 22.2222 28.5041 21.8418 28.0349 21.8418Z"
      fill="#FFD15C"
    />
    <path
      d="M8.21094 4.84962C7.74172 4.84962 7.36134 5.23 7.36134 5.69922C7.36134 6.16845 7.74172 6.54883 8.21094 6.54883C8.68017 6.54883 9.06055 6.16845 9.06055 5.69922C9.06055 5.23 8.68017 4.84962 8.21094 4.84962Z"
      fill="#F8B64C"
    />
    <path
      d="M4.81251 16.1777C4.34328 16.1777 3.9629 16.5581 3.9629 17.0273C3.9629 17.4966 4.34328 17.877 4.81251 17.877C5.28173 17.877 5.66211 17.4966 5.66211 17.0273C5.66211 16.5581 5.28173 16.1777 4.81251 16.1777Z"
      fill="#FFD15C"
    />
  </SvgIcon>
));
